import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "px-6 py-4 cursor-default select-none" }
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { class: "min-w-0" }
const _hoisted_4 = { class: "text-sm font-semibold text-gray-800 truncate" }
const _hoisted_5 = { class: "text-xs text-gray-500 truncate" }
const _hoisted_6 = {
  class: "text-left w-full px-6 py-2 block cursor-not-allowed text-gray-400 select-none",
  "aria-disabled": "true",
  role: "menuitem"
}
const _hoisted_7 = { class: "py-2 font-medium" }
const _hoisted_8 = {
  style: {"grid-template-columns":"2em auto"},
  class: "grid gap-2"
}
const _hoisted_9 = { class: "grid content-center" }
const _hoisted_10 = { class: "h-full inline-flex items-center" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "py-2 font-medium" }
const _hoisted_13 = {
  style: {"grid-template-columns":"2em auto"},
  class: "grid gap-2"
}
const _hoisted_14 = { class: "grid content-center" }
const _hoisted_15 = { class: "h-full text-gray-800 inline-flex items-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "py-2 font-medium" }
const _hoisted_18 = {
  style: {"grid-template-columns":"2em auto"},
  class: "grid gap-2"
}
const _hoisted_19 = { class: "grid content-center" }
const _hoisted_20 = { class: "h-full text-gray-800 inline-flex items-center" }
const _hoisted_21 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserInitialsIcon = _resolveComponent("UserInitialsIcon")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_TooltipTrigger = _resolveComponent("TooltipTrigger")!
  const _component_TooltipContent = _resolveComponent("TooltipContent")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_TooltipProvider = _resolveComponent("TooltipProvider")!
  const _component_DropDown = _resolveComponent("DropDown")!

  return (_openBlock(), _createBlock(_component_DropDown, {
    expand: _ctx.expandDropdown,
    "onUpdate:expand": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.expandDropdown) = $event)),
    "dropdown-class": "mt-1 w-60"
  }, {
    "dropdown-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_UserInitialsIcon, {
            user: _ctx.user,
            size: "lg",
            variant: "filled"
          }, null, 8, ["user"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.displayName), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user?.email || ''), 1)
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.key
        }, [
          (item.type === 'external' && item.disabled)
            ? (_openBlock(), _createBlock(_component_TooltipProvider, {
                key: 0,
                "delay-duration": 200
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Tooltip, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_TooltipTrigger, { "as-child": "" }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_component_Icon, {
                                    src: item.icon
                                  }, null, 8, ["src"])
                                ]),
                                _createElementVNode("span", _hoisted_10, _toDisplayString(item.name), 1)
                              ])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      (item.disabledTooltip)
                        ? (_openBlock(), _createBlock(_component_TooltipContent, { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", null, _toDisplayString(item.disabledTooltip), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            : (item.type === 'external')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: item.href,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "text-left w-full px-6 py-2 block hover:bg-gray-100 cursor-pointer",
                  role: "menuitem",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expandDropdown = false))
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_Icon, {
                          src: item.icon
                        }, null, 8, ["src"])
                      ]),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(item.name), 1)
                    ])
                  ])
                ], 8, _hoisted_11))
              : (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "text-left w-full px-6 py-2 hover:bg-gray-100 cursor-pointer",
                  role: "menuitem",
                  onClick: ($event: any) => (item.onClick()),
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.expandDropdown = false), ["esc"]))
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_Icon, {
                          src: item.icon
                        }, null, 8, ["src"])
                      ]),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(item.name), 1)
                    ])
                  ])
                ], 40, _hoisted_16))
        ], 64))
      }), 128))
    ]),
    default: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "h-full grid content-center cursor-pointer",
        "aria-label": _ctx.$t('layouts.dashboard.topBar.settings.header'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expandDropdown = !_ctx.expandDropdown))
      }, [
        _createVNode(_component_UserInitialsIcon, { user: _ctx.user }, null, 8, ["user"])
      ], 8, _hoisted_21)
    ]),
    _: 1
  }, 8, ["expand"]))
}